// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"7c7a40a0","22":"e08e435f","299":"cd448e37"}[chunkId] + ".css";
};